import { ListSports, ListWagerType } from '@/enums'
import { SportsROState } from '../models'

const initSports = []
Object.values(ListSports).forEach((value) => {
  if (Number.isNaN(Number(value))) {
    initSports.push(value)
  }
})

const initWagerTypes = []
Object.values(ListWagerType).forEach((value) => {
  if (Number.isNaN(Number(value))) {
    initWagerTypes.push(value)
  }
})

export const initialState: SportsROState = {
  isLoading: false,
  sportsRO: null,
  pagination: {
    total: 0,
    limit: 25,
    page: 1,
    pages: 1,
  },
  filters: {
    page: 1,
    limit: 25,
    sports: initSports,
    wagerTypes: initWagerTypes,
  },
}
